import React, { useEffect, useState } from "react";
import { useAuth } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { APP_VERSION, url } from "../../Config";

const About = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const formatDate = (date) => {
    if (!date) return "Not set";
    return new Date(date).toLocaleDateString("en-GB");
  };

  useEffect(() => {
    if (!user?.token) return;

    const fetchUser = async () => {
      try {
        const res = await axios.get(`${url}/api/me`, {
          headers: { Authorization: `Bearer ${user.token}` },
        });
        setProfile(res.data);
      } catch (err) {
        console.error("Failed to fetch user:", err);
        logout();
        navigate("/login");
      }
    };

    fetchUser();
  }, [user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#081421] via-[#0F2A44] to-[#1E5FAF] p-4 sm:p-6 lg:p-12">
      <div className="relative w-full max-w-md sm:max-w-lg md:max-w-2xl bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 p-6 sm:p-8 text-white">
        
        {/* USER BADGES */}
        {profile?.user_type === "premium" && (
          <span className="absolute top-4 right-4 px-3 py-1 text-xs sm:text-sm font-bold rounded-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-white/90 border border-yellow-300/40 shadow-md">
            PREMIUM
          </span>
        )}

        {profile?.user_type === "admin" && (
          <span className="absolute top-4 right-4 px-3 py-1 text-xs sm:text-sm font-bold rounded-full bg-gradient-to-r from-cyan-300 to-blue-500 text-white/90 border border-cyan-300/40 shadow-md">
            ADMIN
          </span>
        )}

        <h1 className="text-3xl sm:text-4xl font-bold mb-6 sm:mb-8 text-center bg-gradient-to-r from-[#4EA8FF] to-[#00D4FF] bg-clip-text text-transparent">
          Your Profile
        </h1>

        {profile ? (
          <div className="space-y-4 sm:space-y-6">

            {/* AVATAR */}
            <div className="flex flex-col items-center">
              <img
                src={profile?.bio?.avatar || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                alt="avatar"
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-full border-2 border-[#4EA8FF] shadow-lg"
              />
              <p className="mt-2 sm:mt-3 text-lg sm:text-xl font-semibold">{profile.username}</p>
              <p className="text-white/60 text-sm sm:text-base">{profile.email}</p>
            </div>

            {/* ACCOUNT INFO */}
            <div className="bg-white/5 rounded-xl p-4 sm:p-5 border border-white/10 space-y-1 sm:space-y-2">
              <h2 className="text-base sm:text-lg font-semibold text-[#4EA8FF] mb-1 sm:mb-2">
                Account Info
              </h2>
              <p className="text-sm sm:text-base"><span className="text-white/60">Joined:</span> {formatDate(profile.createdAt)}</p>
              <p className="text-sm sm:text-base"><span className="text-white/60">Password:</span> *********</p>
            </div>

            {/* BIO */}
            <div className="bg-white/5 rounded-xl p-4 sm:p-5 border border-white/10 space-y-1 sm:space-y-2">
              <h2 className="text-base sm:text-lg font-semibold text-[#4EA8FF] mb-1 sm:mb-2">Bio</h2>
              <p className="text-sm sm:text-base"><span className="text-white/60">Profession:</span> {profile?.bio?.profession || "Not added"}</p>
              <p className="text-sm sm:text-base"><span className="text-white/60">Location:</span> {profile?.bio?.location || "Not added"}</p>
              <p className="text-sm sm:text-base"><span className="text-white/60">Date of Birth:</span> {formatDate(profile?.bio?.dob)}</p>
              <p className="mt-1 sm:mt-2 text-sm sm:text-base">
                <span className="text-white/60">About:</span>
                <br />
                <span className="text-white/80">{profile?.bio?.about || "No bio added yet."}</span>
              </p>
            </div>

            <button
              onClick={handleLogout}
              className="w-full py-3 sm:py-4 rounded-xl font-semibold bg-gradient-to-r from-[#4EA8FF] to-[#00D4FF] text-[#081421] hover:scale-[1.02] transition-all duration-200"
            >
              Logout
            </button>

          </div>
        ) : (
          <p className="text-center text-white/70">Loading profile...</p>
        )}

        <p className="text-center text-white/50 mt-4 sm:mt-6 text-xs sm:text-sm">
          App Version: {APP_VERSION}
        </p>
      </div>
    </div>
  );
};

export default About;